import { SkeletonLoader } from '@/shared/lib/components/SkeletonLoader/SkeletonLoader'

import cls from './catalog-brands-grid-loader.module.scss'

const itemLoaderArray = Array(32).fill(null)

type CatalogBrandsGridLoaderProps = {
	isMobile: boolean
}

export const CatalogBrandsGridLoader = (props: CatalogBrandsGridLoaderProps) => (
	<div className={cls.inner}>
		{itemLoaderArray.map((_, index) => (
			<SkeletonLoader key={index} height={props?.isMobile ? 240 : 410} />
		))}
	</div>
)
